import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  ViewChild
} from '@angular/core';
import { FieldWrapper } from "@ngx-formly/core";
import { CurrencyService } from "../../../service/currency.service";
import { SlSelect } from "@shoelace-style/shoelace";
import { PaymentStateService } from "../../../service/payment-state.service";
import { map, Observable } from "rxjs";

@Component({
  selector: 'app-payment-section',
  templateUrl: './payment-section.component.html',
  styleUrls: ['./payment-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentSectionComponent extends FieldWrapper {

  @ViewChild("select") select!: ElementRef<SlSelect>;

  constructor(
      private currencyService: CurrencyService,
      private paymentStateService: PaymentStateService
  ) { super(); }

  isAdmin(): boolean {
    return this.field.props?.['takeThisForm'];
  }

  getTotalAmountDue(): string {
    const amount = this.field.props?.["totalAmountDue"] || 0;
    return this.currencyService.formatCurrency(amount);
  }

  hasMultiplePayments$(): Observable<boolean> {
    return this.paymentStateService.getPaymentState$().pipe(
      map(paymentState => paymentState.hasMultiplePayments)
    );
  }

  showPayNow$(): Observable<boolean> {
    return this.paymentStateService.getPaymentState$().pipe(
      map(paymentState => paymentState.hasCC || paymentState.hasEFT)
    );
  }

  showOfflinePayment$(): Observable<boolean> {
    return this.paymentStateService.getPaymentState$().pipe(
      map(paymentState => paymentState.hasOfflinePayment)
    );
  }

  onSelectionChange(event: CustomEvent): void {
    const value: string = (event.target as SlSelect).value as string;
    this.paymentStateService.setPaymentType(value);
  }
}
